import {Box, Typography, useTheme} from "@mui/material";

const Footer = () =>{
    const theme = useTheme();

    return <Box py={2} sx={{
        backgroundColor: theme.palette.brDark.main,
        width: '100vw'
    }}>
        <Typography variant='body2' textAlign='center' fontSize='0.8rem' color={theme.palette.brLight.main}>
            ©2024 Pizzeria La Bruschetta - Designed by <a style={{textDecoration: 'none', color: theme.palette.brAccent.main}} href='https://www.lucameledev.it' target='_blank' rel="noreferrer">lucameledev.it</a>
        </Typography>
    </Box>
}

export default Footer;